import { render, staticRenderFns } from "./jubao.vue?vue&type=template&id=24f77c6e"
import script from "./jubao.vue?vue&type=script&lang=js"
export * from "./jubao.vue?vue&type=script&lang=js"
import style0 from "./jubao.vue?vue&type=style&index=0&id=24f77c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports